<label class="form-label w-100 text-start">{{ label }}</label>
<input
  class="s-input form-control opacity_text"
  [type]="type"
  [placeholder]="placeholder"
  [value]="value"
  [disabled]="disabled"
  (input)="handleInput($event)" />
